import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { supabase } from '../lib/supabaseClient';

const RequireSuperAdmin = ({ children }) => {
  const location = useLocation();

  const [status, setStatus] = useState({ loading: true, allowed: false });

  useEffect(() => {
    let mounted = true;

    const check = async () => {
      try {
        const { data, error } = await supabase.auth.getSession();
        if (!mounted) return;
        if (error || !data?.session?.user?.id) {
          setStatus({ loading: false, allowed: false });
          return;
        }

        const userId = data.session.user.id;

        const { data: profile, error: profileError } = await supabase
          .from('profiles')
          .select('role')
          .eq('id', userId)
          .maybeSingle();

        if (!mounted) return;
        if (profileError) {
          setStatus({ loading: false, allowed: false });
          return;
        }

        setStatus({ loading: false, allowed: profile?.role === 'admin' });
      } catch (e) {
        if (!mounted) return;
        setStatus({ loading: false, allowed: false });
      }
    };

    check();

    const { data: sub } = supabase.auth.onAuthStateChange(() => {
      check();
    });

    return () => {
      mounted = false;
      sub?.subscription?.unsubscribe?.();
    };
  }, []);

  if (status.loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-sm text-muted-foreground">로딩 중...</div>
      </div>
    );
  }

  if (!status.allowed) {
    return <Navigate to="/admin-login" replace state={{ from: location?.pathname }} />;
  }

  return children;
};

export default RequireSuperAdmin;
